import {getQuery} from "../../common/utils";

const getStaffSlots = async (businessUid) => {

  let result;
  try {
    result = await getQuery(`platform/v1/businesses/${businessUid}/staff_slots`)
    result = result.data;
  }
  catch (error) {
    result = {code: 'error'};
    console.error(error)
  }

  return result;
}

export const staffService = {
  getStaffSlots
}
